import React from 'react';

import { Tabs } from 'src/components/Tabs/Tabs';

import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import type { TabsType } from './tabsConfigAggregator';

type PageBuilderTabsProps = TabsType;

/**
 * Return the PB Tabs
 * @param props
 * @constructor
 */
export function PageBuilderTabs(props: PageBuilderTabsProps) {
    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderTabsProps>(props);

    const tabsClassNames = ['pageBuilderTabsGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        tabsClassNames.push(...props.cssClasses);
    }

    const borderStyles = {
        borderColor: advancedSettings.borderColor,
        borderStyle: advancedSettings.borderStyle,
        borderWidth: advancedSettings.borderWidth,
    };

    /**
     * We already have a Tabs component, so we can use it directly
     * However, we need to pass the correct props to it
     * So we need to map the children to the correct format
     */
    const tabs = props.children?.map((child) => {
        const id = (child as any).props.data.uniqueID as string;
        const title = (child as any).props.data.tabName as string;

        return {
            content: child,
            id,
            title,
        };
    });

    /**
     * Render the Tabs UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={{
                margin: advancedSettings.margin,
                marginBottom: advancedSettings.marginBottom,
                marginLeft: advancedSettings.marginLeft,
                marginRight: advancedSettings.marginRight,
                marginTop: advancedSettings.marginTop,
                padding: advancedSettings.padding,
                paddingBottom: advancedSettings.paddingBottom,
                paddingLeft: advancedSettings.paddingLeft,
                paddingRight: advancedSettings.paddingRight,
                paddingTop: advancedSettings.paddingTop,
                textAlign: advancedSettings.textAlign,
                minHeight: advancedSettings.minHeight,
            }}
            classNames={tabsClassNames}
        >
            {tabs && (
                <Tabs
                    tabs={tabs}
                    isPageBuilder={true}
                    borderStyles={borderStyles}
                    layoutStyles={{
                        justifyContent: props.tabNavigationAlignment,
                    }}
                />
            )}
        </PageBuilderElementWrapper>
    );
}
